<template lang="pug">
	div.toast.p-3(:class="(active) ? 'active' : ''", :style="top", @click="close")
		div(v-if="!t.icon")
			h5
				b {{t.titulo}}
			span
				| {{t.mensaje}}
		div(v-if="t.icon", style="display:table-row;")
			div(style="display:table-cell;width:40px;vertical-align:middle;font-size:2em;")
				span(:class="t.icon")
			div(style="display:table-cell;vertical-align:middle;")
				h5
					b {{t.titulo}}
				span
					| {{t.mensaje}}
		div.progreso(v-if="t.type === 'progress'", :style="estiloProgreso")
</template>

<script>
export default {
	props: ['t', 'top'],

	data () {
		return {
			active: false,
			closed: false,
			timeout: null
		}
	},

	created () {
		window.setTimeout(() => {
			this.active = true
		}, 100)

		if (this.t.timeout) {
			this.timeout = window.setTimeout(() => {
				if (!this.closed) {
					this.close(true)
				}
			}, this.t.timeout * 1000)
		}
	},
	watch: {
		t (newVal, oldVal) {
			if (typeof newVal.active === 'boolean') {
				this.active = newVal.active
			}
			if (typeof newVal.closed === 'boolean') {
				this.closed = newVal.closed
			}
		}
	},
	computed: {
		estiloProgreso () {
			if (this.t.type !== 'progress') {
				return {}
			}

			return {
				width: this.t.progress + '%',
				transition: 'width 500ms ease-in-out'
			}
		}
	},

	methods: {
		close (auto) {
			auto = (typeof auto !== 'boolean') ? false : auto

			if (!this.t.closable && !auto) {
				return
			}
			this.active = false
			this.closed = true

			window.clearTimeout(this.timeout)
			window.setTimeout(() => {
				this.$store.commit('toast/delete', this.t.id)
			}, 500)
		}
	}
}
</script>
<style scoped>
	.toast {
		position: fixed;
		display: block;
		width: 300px;
		right: 10px;
		transform: translateX(320px);
		transition: transform 400ms ease-in-out, top 200ms ease-in-out;
		border-radius: 10px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
		text-align: left;
		z-index: 2002;
		cursor: pointer;
	}

	.active {
		transform: translateX(0);
	}

	.progreso {
		position: absolute;
		display: block;
		left: 0;
		right: 0;
		bottom: 0;
		height: 10px;
		background-color: rgba(0,0,0,0.3);
		border-radius: 0 0 10px 10px;
	}
</style>




// WEBPACK FOOTER //
// src/modulos/core/vue/components/toasts/toast.vue